import React, {useContext} from 'react'
import { BrowserRouter as Switch, Route } from "react-router-dom";
import Games from "./Games/Games"
import Movie from "./Movie/Movie"
import DetailGames from "./Games/DetailGames"
import DetailMovie from "./Movie/DetailMovie"
import Carousell from "./Carousell"
import MovieList from "./Movie/MovieList"
import GamesList from "./Games/GamesList"
import MovieForm from "./Movie/MovieForm"
import GamesForm from "./Games/GamesForm"
import Register from "./Register"
import Login from "./Login"
import {UserContext} from "./UserContext"
import SideBar from "./SideBar"
import ChangePassword from "./ChangePassword"

function Section() {
    const [user] = useContext(UserContext)
    // const PrivateRoute = ({...rest}) =>{
    //     if (user){
    //       return <Route {...rest}/>
    //     }else{
    //       return <Redirect to="/login" />
    //     }
    //   }

    const LoginRoute = ({...rest}) =>{
        if (user){
          return<></>
        }else{
          return <Route {...rest}/>
        }
      }
    return(
        <Switch>
            <div style={{backgroundColor:"#f0f2f5"}}>
            <div className="container" style={{backgroundColor:"white", border:"2px"}}>
            <Route exact path="/">
            <Carousell/>
                <Movie/>
                <Games/>
            </Route>
            </div>
            </div>
            <Route exact path="/movie">
                <Movie/>
            </Route>
            <Route exact path="/settingmovie">
            <div style={{display:"flex"}}>
            <div>
                <SideBar/>
                </div>
                <div>
                <MovieList/>
                </div>
                </div>
            </Route>
            <Route exact path="/movie/edit/:id">
                <MovieForm/>
            </Route>
            <Route exact path="/movie/create">
                <MovieForm/>
            </Route>
            <Route exact path="/movie/detail/:id">
                <DetailMovie/>
            </Route>
            <Route exact path="/games">
                <Games/>
            </Route>
            <Route exact path="/games/edit/:id">
                <GamesForm/>
            </Route>
            <Route exact path="/games/create">
                <GamesForm/>
            </Route>
            <Route exact path="/settinggames">
            <div style={{display:"flex"}}>
            <div>
                <SideBar/>
                </div>
                <div>
                <GamesList/>
                </div>
                </div>
            </Route>
            <Route exact path="/games/detail/:id">
                <DetailGames/>
            </Route>

            {/* <PrivateRoute exact path="/">
            <PrivateContestant/>
          </PrivateRoute> */}
            <LoginRoute exact path="/register">
            <Register/>
          </LoginRoute>
          <LoginRoute exact path="/login">
            <Login/>
          </LoginRoute>
          <Route exact path="/changepassword">
              <ChangePassword/>
          </Route>
        </Switch>
    )
}
export default Section